import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { getClientBaseURL } from "@/lib/base-url";

export const OPERATOR_ROLE = "operator";
export const INSPECTOR_ROLE = "inspector";
export const SECURITY_GUARD_ROLE = "security_guard";
export const MECHANIC_ROLE = "mechanic";
export const MECHANIC_TRAILER_ROLE = "mechanic_trailer";
export const MECHANIC_LEADER_ROLE = "mechanical_leader";
export const COORDINATOR_ROLE = "coordinator";

export const authClient = createAuthClient({
  baseURL: getClientBaseURL(),
  plugins: [adminClient()],
});

// Export hooks from the singleton client to prevent duplicate IndexedDB instances
export const { useSession, signIn, signOut, signUp } = authClient;

// Legacy export for backward compatibility
export const client = authClient;
